export default __webpack_public_path__ + "static/nykoping_logotyp-932fe4959a3b640bb8dd71b29676f5b9.png";